export var DsjStoreName = 'AB_DSJ_STORE';